import type { MouseEventHandler } from 'react';
import { forwardRef, useCallback, useContext } from 'react';

import AtlasKitEditIcon from '@atlaskit/icon/core/edit';
import { intl } from '@trello/i18n';
import { Button } from '@trello/nachos/button';
import { Tooltip } from '@trello/nachos/tooltip';
import type { CardFrontTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { CardFrontContext } from './CardFrontContext';

import styles from './CardFrontEditButton.less';

export const CardFrontEditButton = forwardRef<HTMLButtonElement>((_, ref) => {
  const { openQuickCardEditorOverlay } = useContext(CardFrontContext);

  const onClick = useCallback<MouseEventHandler>(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      openQuickCardEditorOverlay();
    },
    [openQuickCardEditorOverlay],
  );

  return (
    <Tooltip
      content={intl.formatMessage({
        id: 'templates.card_front.edit-card',
        defaultMessage: 'Edit card',
        description: 'Edit card tooltip',
      })}
    >
      <Button
        aria-label={intl.formatMessage({
          id: 'templates.card_front.edit-card',
          defaultMessage: 'Edit card',
          description: 'Edit card button',
        })}
        className={styles.editButton}
        iconBefore={
          <AtlasKitEditIcon
            label={intl.formatMessage({
              id: 'templates.card_front.edit-card',
              defaultMessage: 'Edit card',
              description: 'Edit card button',
            })}
            color="currentColor"
          />
        }
        onClick={onClick}
        ref={ref}
        testId={getTestId<CardFrontTestIds>('quick-card-editor-button')}
      />
    </Tooltip>
  );
});
